import api from '@/helpers/api';

export default {
  fetchInstantReplyList({ commit, rootState }, merchantId) {
    commit('START_LOADING_INSTANT_REPLIES');
    api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/business/${merchantId}/instant-replies/list`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_INSTANT_REPLIES_LIST', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchInstantReply({ commit, rootState }, data) {
    api('GET', `/w/organisation/${rootState.organisation.currentOrganisation.id}/business/${data.businessId}/instant-replies/${data.replyId}`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_INSTANT_REPLY', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  // fetchInstantReplyBatch({ commit, rootState }, data) {
  //   api('GET', `/w/organisation/${rootState.organisation.currentOrganisation.id}/business/${data.business_uid}/instant-replies/list`, {}, null, 'w')
  //     .then((response) => {
  //       if (response.status === 200) {
  //         commit('SET_INSTANT_REPLY', response.data);
  //       }
  //     })
  //     .catch((error) => {
  //       commit('API_ERROR', error.response);
  //     });
  // },
  setInstantReplyOrder({ rootState }, payload) {
    const request = api('PUT', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies/order`, payload.data, null, 'w');
    return request;
  },
  createInstantReply({ commit, rootState }, payload) {
    commit('INSTANT_REPLY_SAVED', false);
    const request = api('POST', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('INSTANT_REPLY_SAVED', {
            reply_id: response.data.instant_reply.id,
            temp_id: payload.temp_id,
          });
        }
      })
      .catch((error) => {
        commit('API_ERROR', {
          error: error.response,
          reply_id: payload.temp_id,
        });
      });

    return request;
  },
  updateInstantReply({ commit, rootState }, payload) {
    commit('INSTANT_REPLY_SAVED', false);

    if (payload.data && payload.data.messages) {
      payload.data.messages.forEach((message) => {
        message.text = message.text.replaceAll('{{contact name}}', '{{contact_name}}');
        message.text = message.text.replaceAll('{{number name}}', '{{business_name}}');
      });
    }

    api('PUT', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies/${payload.reply_id}`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('INSTANT_REPLY_SAVED', {
            reply_id: payload.reply_id,
            // message_ids: response.data.message_ids,
            // uploaded_files: response.data.uploaded_files,
            messages: response.data.instant_reply.messages,
          });
        }
      })
      .catch((error) => {
        commit('API_ERROR', {
          error: error.response,
          reply_id: payload.reply_id,
        });
      });
  },
  updateReplyStatus({ rootState }, payload) {
    api('PUT', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.businessId}/instant-replies/${payload.replyId}`, payload.data, null, 'w')
      .catch((error) => {
        // TODO add error handling
      });
  },
  deleteInstantReply({ commit, rootState }, payload) {
    commit('INSTANT_REPLY_DELETED', false);
    api('DELETE', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies/${payload.reply_id}`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('INSTANT_REPLY_DELETED', payload.reply_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteInstantReplyMessage({ commit, rootState }, payload) {
    commit('INSTANT_REPLY_MESSAGE_DELETED', false);
    const request = api('DELETE', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies/${payload.reply_id}/messages/${payload.message_id}`, payload.data, null, 'w');
    request.then((response) => {
      if (response.status === 200) {
        commit('INSTANT_REPLY_MESSAGE_DELETED', payload.message_id);
      }
    }).catch((error) => {
      commit('API_ERROR', error.response);
    });

    return request;
  },
  fetchKeywordAnalytics({ commit }, payload) {
    api('GET', `/merchants/${payload.merchant_id}/instant-replies/${payload.reply_id}/analytics`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_KEYWORD_ANALYTICS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  fetchAutomationRules({ commit }, payload) {
    commit('START_LOADING_RULES');
    api('GET', `/merchants/${payload.merchant_id}/automation-rules`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_RULE_LIST', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  createAutomationRule({ commit }, payload) {
    commit('AUTOMATION_RULE_SAVED', false);
    api('POST', `/merchants/${payload.merchant_id}/automation-rules`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('AUTOMATION_RULE_SAVED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateAutomationRule({ commit }, payload) {
    commit('AUTOMATION_RULE_SAVED', false);
    api('PUT', `/merchants/${payload.merchant_id}/automation-rules/${payload.rule_id}`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('AUTOMATION_RULE_SAVED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteAutomationRule({ commit }, payload) {
    commit('AUTOMATION_RULE_DELETED', false);
    api('DELETE', `/merchants/${payload.merchant_id}/automation-rules/${payload.rule_id}`)
      .then((response) => {
        if (response.status === 200) {
          commit('AUTOMATION_RULE_DELETED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  fetchSettings({ commit, rootState }, merchantId) {
    const request = api('GET', `/organisation/${rootState.organisation.currentOrganisation.id}/business/${merchantId}/instant-replies/settings`, null, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_AUTOMATION_SETTINGS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  updateSettings({ commit, rootState }, payload) {
    commit('AUTOMATION_SETTINGS_SAVED', false);
    const request = api('PUT', `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies/settings`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('AUTOMATION_SETTINGS_SAVED', payload.merchant_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  updateUnsubscribeMessage({ commit, rootState }, payload) {
    commit('UNSUBSCRIBE_MESSAGE_SAVED', false);
    api('PUT', `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/instant-replies/unsubscribe-message`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('UNSUBSCRIBE_MESSAGE_SAVED', payload.merchant_id);
          commit('UPDATE_UNSUBSCRIBED_MESSAGE', payload.data.unsubscribe_message);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error);
      });
  },

  uploadTempFile({ commit, rootState }, payload) {
    commit('FILE_UPLOADED', false);
    api('POST', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.businessId}/instant-replies/upload`, payload.data, {
      'Content-Type': 'multipart/form-data',
    }, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('FILE_UPLOADED', {
            message_id: payload.message_id,
            file: response.data,
          });
        }
      })
      .catch((error) => {
        const errorData = error.response ? error.response : {
          status: 413,
          message: 'Request Entity too large.',
        };
        commit('FILE_UPLOAD_ERROR', {
          sid: payload.data.get('temp_sid'),
          error: errorData,
        });
      });
  },
};
